var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobiilivarmenne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-12 -12 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.096 10.62l6.55-6.553c.508.455.986.942 1.433 1.457l-1.443 1.443-10.635 10.64-6.138-6.141v-.846h2.043L16 14.716l4.092-4.094v-.002h.003zM9.863 21.902v-9.05l2.043 2.044v7.006H9.863zm12.274 0h-2.044v-7.003l2.044-2.044v9.047zm6.612-15.548A15.907 15.907 0 0 1 32 16c0 8.822-7.175 16-15.995 16S.011 24.822.011 16H0C0 7.178 7.175 0 15.994 0h.011c3.703 0 7.113 1.27 9.826 3.392L24.38 4.844a13.868 13.868 0 0 0-8.363-2.806h-.022c-7.689 0-13.945 6.252-13.956 13.94h.01V16c0 7.699 6.261 13.962 13.957 13.962 7.696 0 13.958-6.263 13.958-13.962v-.022a13.878 13.878 0 0 0-2.668-8.17l.84-.84.614-.614z",
    fill: "#231F20",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiilivarmenne);
export default __webpack_public_path__ + "static/media/mobiilivarmenne.eede417cbf2cdfbedb7f57eabc9cedc5.svg";
export { ForwardRef as ReactComponent };